// extracted by mini-css-extract-plugin
module.exports =  {"container":"_1c9529d521--container--yh7u0","image":"_1c9529d521--image--ec2vI","title":"_1c9529d521--title--p77ke","text":"_1c9529d521--text--vpTuE"};